module.exports = __webpack_public_path__ + "img/ETH-icon.abd10825.svg";